var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_156_1140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM8.749 5.646C8.68729 5.57881 8.61273 5.52468 8.52973 5.48682C8.44673 5.44896 8.35698 5.42814 8.26579 5.42559C8.1746 5.42304 8.08382 5.4388 7.99883 5.47196C7.91384 5.50512 7.83637 5.55498 7.771 5.61862C7.70563 5.68225 7.65369 5.75835 7.61825 5.84241C7.58282 5.92647 7.56461 6.01679 7.5647 6.10802C7.56479 6.19925 7.58319 6.28953 7.61879 6.37352C7.6544 6.45751 7.7065 6.5335 7.772 6.597L11.174 10.088L7.777 13.508C7.70918 13.5704 7.65471 13.6459 7.61688 13.7299C7.57905 13.814 7.55864 13.9048 7.55689 13.9969C7.55514 14.0891 7.57208 14.1806 7.60669 14.266C7.64131 14.3514 7.69287 14.429 7.75827 14.4939C7.82368 14.5588 7.90156 14.6098 7.98722 14.6438C8.07288 14.6778 8.16454 14.6941 8.25667 14.6917C8.3488 14.6892 8.43948 14.6682 8.52324 14.6297C8.607 14.5913 8.6821 14.5363 8.744 14.468L12.614 10.574C12.7403 10.4471 12.8116 10.2756 12.8125 10.0965C12.8135 9.91747 12.744 9.74524 12.619 9.617L8.749 5.646Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_1140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNext);
export default __webpack_public_path__ + "static/media/circle-next.15e9b2a9fda1e3515572e7b45e1bd42b.svg";
export { ForwardRef as ReactComponent };